<template>
  <el-form :inline="true" :model="formTenant">
    <!-- 添加4G锁 -->
    <el-dialog
      title="添加4G门锁"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="add4GNetLockVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="fourGNetLockForm"
        ref="fourGNetLockForm"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.lockOrder')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="fourGNetLockForm.lockId"
            :placeholder="$t('apartmentRoomDetail.lockOrder')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.lockName')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="fourGNetLockForm.lockName"
            :placeholder="$t('apartmentRoomDetail.lockName')"
            style="width: 200px"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="add4GNetLock()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="add4GNetLockVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加NB锁 -->
    <el-dialog
      title="添加NB门锁"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addNBNetLockVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="nbNetLockForm"
        ref="nbNetLockForm"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.lockOrder')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="nbNetLockForm.lockId"
            :placeholder="$t('apartmentRoomDetail.lockOrder')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.lockName')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="nbNetLockForm.lockName"
            :placeholder="$t('apartmentRoomDetail.lockName')"
            style="width: 200px"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="addNBNetLock()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addNBNetLockVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加网关 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.addGateway')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addGatewayVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="gatewayForm"
        ref="gatewayForm"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.gatewayName')"
          label-width="120px"
          prop="addGatewayName"
          :rules="[
            {
              required: true,
              message: $t('apartmentRoomDetail.gatewayName-input'),
            },
          ]"
        >
          <el-input
            v-model="gatewayForm.addGatewayName"
            :placeholder="$t('apartmentRoomDetail.gatewayName')"
            maxlength="20"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.number')"
          label-width="120px"
          prop="addGatewayNum"
          :rules="[
            { required: true, message: $t('apartmentRoomDetail.number-input') },
          ]"
        >
          <el-input
            v-model="gatewayForm.addGatewayNum"
            :placeholder="$t('apartmentRoomDetail.number')"
            maxlength="20"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="addGateway()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addGatewayVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加租客 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.addTenant')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addTenantVisible"
      width="450px"
    >
      <el-form
        :inline="true"
        :model="formAddTenant"
        ref="formAddTenant"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.tenantName')"
          label-width="120px"
          prop="tenantName"
          :rules="[{ required: true, message: '租客名称不能为空' }]"
        >
          <el-input
            v-model="formAddTenant.tenantName"
            :placeholder="$t('apartmentRoomDetail.tenantName')"
            maxlength="12"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('apartmentRoomDetail.IDCard')"
          label-width="120px"
          prop="tenantIdentityId"
        >
          <el-input
            v-model="formAddTenant.tenantIdentityId"
            :placeholder="$t('apartmentRoomDetail.IDCard')"
            maxlength="18"
            show-word-limit
            style="width: 250px"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('apartmentRoomDetail.mobile')"
          label-width="120px"
          prop="mobile"
        >
          <el-input
            v-model.number="formAddTenant.mobile"
            :placeholder="$t('apartmentRoomDetail.mobile')"
            maxlength="18"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.email')"
          label-width="120px"
          prop="email"
          :rules="[
            {
              type: 'email',
              message: $t('apartmentRoomDetail.email-input'),
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input
            v-model="formAddTenant.email"
            :placeholder="$t('apartmentRoomDetail.email')"
            maxlength="18"
            style="width: 250px"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="confirmAddTenant">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="closeAddTenant">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 续租 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.relet')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="reletVisible"
      width="450px"
    >
      <el-form-item>
        <el-radio-group v-model="dateRadio" @change="dateChange">
          <el-radio-button :label="0" value="0">{{
            $t("apartmentRoomDetail.day")
          }}</el-radio-button>
          <el-radio-button :label="1" value="1">{{
            $t("apartmentRoomDetail.week")
          }}</el-radio-button>
          <el-radio-button :label="2" value="2">{{
            $t("apartmentRoomDetail.month")
          }}</el-radio-button>
          <el-radio-button :label="3" value="3">{{
            $t("apartmentRoomDetail.quarter")
          }}</el-radio-button>
          <el-radio-button :label="4" value="4">{{
            $t("apartmentRoomDetail.year")
          }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <div class="block">
          <span class="demonstration">{{
            $t("apartmentRoomDetail.date")
          }}</span>
          <el-date-picker
            v-model="reletEndDate"
            type="date"
            :picker-options="pickerOptionsEnd"
            style="width: 140px"
            :placeholder="$t('apartmentRoomDetail.chooseDate')"
          >
          </el-date-picker>
          <el-time-select
            v-model="reletEndTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30',
            }"
            style="width: 100px"
            :placeholder="$t('apartmentRoomDetail.chooseTime')"
          >
          </el-time-select>
        </div>
      </el-form-item>
      <el-form-item
        style="display: flex; justify-content: center; align-items: center"
      >
        <el-button type="primary" @click="reletConfirm">{{
          $t("apartmentRoomDetail.confirm")
        }}</el-button>
        <el-button type="primary" @click="reletVisible = false">{{
          $t("apartmentRoomDetail.cancel")
        }}</el-button>
      </el-form-item>
    </el-dialog>
    <!-- 选择租客 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.chooseTenant')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="tenantListVisible"
      width="600px"
      style="margin-top: -50px"
    >
      <el-form-item
        :label="$t('apartmentRoomDetail.tenantName')"
        style="margin-top: -15px"
      >
        <el-input v-model="selectForm.tenantName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item style="margin-top: -15px">
        <el-button type="primary" @click="onSelectTenant">{{
          $t("apartmentRoomDetail.qurey")
        }}</el-button>
      </el-form-item>
      <el-table
        ref="tenantList"
        :data="tenantList"
        highlight-current-row
        @current-change="handleCurrentChangeDetail"
        height="280px"
        style="margin-top: -10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="tenantName"
          :label="$t('apartmentRoomDetail.tenantName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantPhone"
          :label="$t('apartmentRoomDetail.tenantPhone')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="tenantEmail"
          :label="$t('apartmentRoomDetail.tenantEmail')"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="tenantTotal"
          :offset="tenantPageData.tenantOffset"
          :pageSize="tenantPageData.tenantPageNumber"
          @handleSizeChangeSub="tenantHandleSizeChange"
          @handleCurrentChangeSub="tenantHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseTenant">{{
          $t("apartmentRoomDetail.confirmChoose")
        }}</el-button>
        <el-button
          type="primary"
          @click="
            tenantListVisible = false;
            checkInVisible = true;
          "
          >{{ $t("apartmentRoomDetail.cancel") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 租客入住 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.tenantCheckIn')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="checkInVisible"
      width="600px"
      style="margin-top: -50px"
    >
      <el-form
        :inline="true"
        :model="formTenant"
        ref="formTenant"
        class="demo-ruleForm"
        style="margin-top: -20px"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.tenant')"
          label-width="150px"
          prop="tenantName"
          :rules="[
            { required: true, message: $t('apartmentRoomDetail.chooseTenant') },
          ]"
        >
          <el-col :span="14">
            <el-input
              v-model="formTenant.tenantName"
              :placeholder="$t('apartmentRoomDetail.tenantInfo')"
            ></el-input>
          </el-col>
          <el-col
            :span="10"
            style="display: flex; justify-content: center; align-items: center"
          >
            <el-button-group style="width: 120px">
              <el-button
                size="medium"
                :title="$t('apartmentRoomDetail.chooseTenant1')"
                icon="el-icon-search"
                type="primary"
                @click="chooseTenant"
              ></el-button>
              <el-button
                size="medium"
                :title="$t('apartmentRoomDetail.addTenant')"
                icon="el-icon-plus"
                type="primary"
                @click="addTenant"
              ></el-button>
            </el-button-group>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="$t('apartmentRoomDetail.roomInfo')"
          label-width="150px"
          prop="mobile"
        >
          <el-col :span="12">
            <el-input
              v-model="currCheckInRoomData.roomName"
              :placeholder="$t('apartmentRoomDetail.roomName')"
              maxlength="18"
              style="width: 170px"
              disabled
            ></el-input>
          </el-col>
          <el-col :span="12">
            <el-radio-group
              v-model="formTenant.manage"
              size="mini"
              style="width: 200px"
            >
              <el-tooltip
                :content="$t('apartmentRoomDetail.tenantOnlyOpenDoor')"
                placement="top"
                effect="light"
              >
                <el-radio label="0">{{
                  $t("apartmentRoomDetail.tenant")
                }}</el-radio>
              </el-tooltip>
              <el-tooltip
                :content="$t('apartmentRoomDetail.adminLockManage')"
                placement="top"
                effect="light"
              >
                <el-radio label="1">{{
                  $t("apartmentRoomDetail.admin")
                }}</el-radio>
              </el-tooltip>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.isSendMessage')"
          label-width="150px"
          style="width: 450px"
          prop="mobile"
        >
          <el-radio v-model="formTenant.sendMessageChecked" label>{{
            $t("apartmentRoomDetail.nosend")
          }}</el-radio>
          <el-radio v-model="formTenant.sendMessageChecked" label="0">{{
            $t("apartmentRoomDetail.SMS")
          }}</el-radio>
          <el-radio v-model="formTenant.sendMessageChecked" label="1">{{
            $t("apartmentRoomDetail.sendEmail")
          }}</el-radio>
        </el-form-item>
        <!-- <el-form-item label="授权内容" label-width="100px" prop="mobile">
          <el-col :span="18">
            <el-radio v-model="formTenant.validType" label="0">密码</el-radio>
            <el-radio v-show="this.formTenantInfo.deviceType==1" v-model="formTenant.validType" label="1">卡片</el-radio>
            <el-radio v-show="this.formTenantInfo.deviceType==4" v-model="formTenant.validType" label="2">蓝牙钥匙</el-radio>
          </el-col>
          <el-col :span="6">
            <el-input
              v-show="formTenant.validType == '1'"
              v-model="formTenant.card"
              placeholder="请输入卡号"
              style="width:130px"
            ></el-input>
            <el-input v-show="formTenant.validType=='2'" v-model="formTenant.cloudUser" placeholder="请输入云用户" style="width:130px"></el-input>
          </el-col>
        </el-form-item> -->
        <el-form-item
          :label="$t('apartmentRoomDetail.beginDate')"
          label-width="150px"
          prop="date1"
          :rules="[
            {
              required: true,
              message: $t('apartmentRoomDetail.beginDate-input'),
            },
          ]"
        >
          <el-date-picker
            type="date"
            :placeholder="$t('apartmentRoomDetail.chooseDate')"
            v-model="formTenant.date1"
            style="width: 200px"
          ></el-date-picker>
          -
          <el-time-select
            v-model="formTenant.time1"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30',
            }"
            style="width: 150px"
            :placeholder="$t('apartmentRoomDetail.chooseTime')"
          >
          </el-time-select>
        </el-form-item>

        <el-form-item
          :label="$t('apartmentRoomDetail.endDate')"
          label-width="150px"
          prop="date2"
          :rules="[
            {
              required: true,
              message: $t('apartmentRoomDetail.endDate-input'),
            },
          ]"
        >
          <el-date-picker
            type="date"
            placeholder="$t('apartmentRoomDetail.chooseDate')"
            v-model="formTenant.date2"
            style="width: 200px"
          ></el-date-picker>
          -
          <!-- <el-time-picker
            placeholder="选择时间"
            v-model="formTenant.time2"
            style="width:150px"
          ></el-time-picker> -->
          <el-time-select
            v-model="formTenant.time2"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30',
            }"
            style="width: 150px"
            placeholder="$t('apartmentRoomDetail.chooseTime')"
          >
          </el-time-select>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="confirmCheckIn">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="checkInVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加离线锁 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.addOfflineLock')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addOfflineVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="offlineForm"
        ref="offlineForm"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.lockNum')"
          label-width="120px"
          prop="lockId"
          :rules="[
            {
              required: true,
              message: $t('apartmentRoomDetail.lockNum-input'),
            },
          ]"
        >
          <el-input
            type="text"
            v-model="offlineForm.lockId"
            :placeholder="$t('apartmentRoomDetail.lockNum')"
            maxlength="8"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.lockNum')"
          label-width="120px"
          prop="lockName"
          :rules="[
            {
              required: true,
              message: $t('apartmentRoomDetail.lockNum-input'),
            },
          ]"
        >
          <el-input
            type="text"
            v-model="offlineForm.lockName"
            placeholder="$t('apartmentRoomDetail.lockName')"
            maxlength="30"
            show-word-limit
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="addOfflineLock()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addOfflineVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加联网锁 -->
    <el-dialog
      :title="$t('apartmentRoomDetail.addNetwork')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addNetLockVisible"
      width="400px"
    >
      <el-form
        :inline="true"
        :model="netLockForm"
        ref="netLockForm"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('apartmentRoomDetail.gateway')"
          label-width="120px"
        >
          <el-select
            v-model="netLockForm.gatewayId"
            :placeholder="$t('apartmentRoomDetail.chooseGateway')"
            style="width: 200px"
            prop="gatewayId"
            filterable
          >
            <el-option
              v-for="item in this.$store.state.gatewayList"
              :key="item.deviceId"
              :label="item.deviceName"
              :value="item.deviceId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.lockOrder')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="netLockForm.lockId"
            :placeholder="$t('apartmentRoomDetail.lockOrder')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('apartmentRoomDetail.lockName')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="netLockForm.lockName"
            :placeholder="$t('apartmentRoomDetail.lockName')"
            style="width: 200px"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="addNetLock()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addNetLockVisible = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-card class="box-card clearfloat" min-width="800px">
      <div
        slot="header"
        style="font-weight: bold; height: 10px; line-height: 10px"
      >
        <span>{{ this.currRoomData.roomName }}</span>
      </div>
      <div style="margin-top: -15px; height: 180px">
        <el-col :span="8" style="border-right: 1px #000000 dashed">
          <div style="width: 100%; height: 195px; overflow: auto">
            <el-form-item
              :label="$t('apartmentRoomDetail.operate')"
              style="width: 280px"
            >
              <el-button
                type="primary"
                v-show="
                  this.currRoomData.tenantName == '' ||
                  this.currRoomData.tenantName == null
                "
                size="mini"
                @click="openCheckIn"
                >{{ $t("update.checkIn") }}</el-button
              >
              <el-button
                type="primary"
                v-show="
                  this.currRoomData.isAuthorized == 0 &&
                  this.currRoomData.tenantName != '' &&
                  this.currRoomData.tenantName != null
                "
                size="mini"
                @click="reauthorization()"
                >{{ $t("update.authAgain") }}</el-button
              >
              <el-button
                type="primary"
                v-show="
                  this.currRoomData.isAuthorized != 0 &&
                  this.currRoomData.tenantName != '' &&
                  this.currRoomData.tenantName != null
                "
                size="mini"
                @click="relet"
                >{{ $t("update.relet") }}</el-button
              >
              <el-button
                type="danger"
                v-show="
                  this.currRoomData.tenantName != '' &&
                  this.currRoomData.tenantName != null
                "
                size="mini"
                @click="checkOut"
                >{{ $t("update.checkOut") }}</el-button
              >
            </el-form-item>
            <el-form-item
              :label="$t('apartmentRoomDetail.operate')"
              style="width: 230px; margin-top: -35px"
              v-show="
                this.currRoomData.tenantName != '' &&
                this.currRoomData.tenantName != null
              "
            >
              {{ this.currRoomData.tenantName }}
            </el-form-item>
            <el-form-item
              :label="$t('apartmentRoomDetail.type')"
              style="width: 250px; margin-top: -36px"
              v-show="
                this.currRoomData.tenantName != '' &&
                this.currRoomData.tenantName != null
              "
            >
              {{
                this.formTenantInfo.isManage == 0
                  ? $t("apartmentRoomDetail.tenant")
                  : this.formTenantInfo.isManage == 1
                  ? $t("apartmentRoomDetail.admin")
                  : ""
              }}
            </el-form-item>
            <el-form-item
              :label="$t('apartmentRoomDetail.phone')"
              style="width: 230px; margin-top: -36px"
              v-show="
                this.currRoomData.tenantName != '' &&
                this.currRoomData.tenantName != null
              "
            >
              {{ this.currRoomData.tenantPhone }}
            </el-form-item>
            <el-form-item
              :label="$t('apartmentRoomDetail.leaseStart')"
              v-show="
                this.currRoomData.tenantName != '' &&
                this.currRoomData.tenantName != null
              "
              style="width: 230px; margin-top: -36px"
            >
              {{ this.formTenantInfo.beginTime }}
            </el-form-item>
            <el-form-item
              :label="$t('apartmentRoomDetail.leaseEnd')"
              v-show="
                this.currRoomData.tenantName != '' &&
                this.currRoomData.tenantName != null
              "
              style="width: 230px; margin-top: -36px"
            >
              {{ this.formTenantInfo.endTime }}
            </el-form-item>
          </div>
        </el-col>
        <el-col
          :span="8"
          style="border-right: 1px #000000 dashed; background-color: #f2f6fc"
        >
          <div style="width: 100%; height: 195px; overflow: auto">
            <el-col :span="24">
              <div style="margin-left: 10px; margin-bottom: 5px">
                {{ $t("apartmentRoomDetail.authDetail") }}
              </div>
            </el-col>
            <el-row
              style="padding: 5px; font-size: 14px"
              v-show="this.currRoomData.isAuthorized == 1"
            >
              <el-col :span="24">
                {{ $t("apartmentRoomDetail.authName") }}:{{
                  this.authInfoForm.authorizationName
                }}
              </el-col>
            </el-row>
            <el-row
              style="padding: 5px; font-size: 14px"
              v-show="this.currRoomData.isAuthorized == 1"
            >
              <el-col :span="24">
                {{ $t("apartmentRoomDetail.authType") }}:{{
                  this.authInfoForm.authorizationType
                }}
              </el-col>
            </el-row>
            <el-row
              style="padding: 5px; font-size: 14px"
              v-show="this.currRoomData.isAuthorized == 1"
            >
              <el-col :span="24">
                {{ $t("apartmentRoomDetail.authContent") }}:{{
                  this.authInfoForm.authorizationContent
                }}
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="8">
          <el-col :span="24">
            <div style="margin-left: 10px">
              {{ $t("apartmentRoomDetail.commonOperate") }}
            </div>
          </el-col>
          <div style="width: 100%; height: 175px; overflow: auto">
            <div style="width: 100%; min-width: 300px; height: 30px">
              <el-col :span="12" style="margin-top: 10px">
                <div
                  style="margin-left: 10px"
                  v-show="this.showAddGatewayBtn == true"
                >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="addGatewayVisible = true"
                    >{{ $t("apartmentRoomDetail.bindGateway") }}</el-button
                  >
                </div>
              </el-col>
            </div>
            <div style="width: 100%; min-width: 300px">
              <el-divider><i class="el-icon-unlock"></i></el-divider>
              <el-col :span="12" style="margin-top: 5px">
                <div
                  style="margin-left: 10px"
                  v-show="this.showAddLockBtn == true"
                >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="addOfflineVisible = true"
                    >{{ $t("apartmentRoomDetail.bindOfflineLock") }}</el-button
                  >
                </div>
              </el-col>
              <el-col :span="12" style="margin-top: 5px">
                <div
                  style="margin-left: 10px"
                  v-show="this.showAddLockBtn == true"
                >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="addNetLockVisible = true"
                    >{{ $t("apartmentRoomDetail.bindNetworkLock") }}</el-button
                  >
                </div>
              </el-col>
              <el-col
                :span="12"
                style="margin-top: 5px"
                v-show="this.$util.defLanguage == 'zh'"
              >
                <div
                  style="margin-left: 10px"
                  v-show="this.showAddLockBtn == true"
                >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="addNBNetLockVisible = true"
                    >绑定NB联网锁</el-button>
                </div>
              </el-col>
              <el-col
                :span="12"
                style="margin-top: 5px"
                v-show="this.$util.defLanguage == 'zh'"
              >
                <div
                  style="margin-left: 10px"
                  v-show="this.showAddLockBtn == true"
                >
                  <el-button
                    style="width: 150px"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    @click="add4GNetLockVisible = true"
                    >绑定4G联网锁</el-button
                  >
                </div>
              </el-col>
            </div>
          </div>
        </el-col>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 3px">
      <div
        slot="header"
        style="font-weight: bold; height: 10px; line-height: 10px"
      >
        <span>{{ $t("apartmentRoomDetail.deviceList") }}</span>
      </div>
      <el-table
        :data="this.tableData"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        empty-text="No Data"
        border
      >
        <!-- <el-table-column
          type="index"
          :label="$t('apartmentRoomDetail.order')"
          width="70"
          align="center"
        ></el-table-column> -->
        <el-table-column
          prop="deviceId"
          :label="$t('apartmentRoomDetail.number')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="apartmentName"
          :label="$t('apartmentRoomDetail.apartmentName')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="roomName"
          :label="$t('apartmentRoomDetail.roomName')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="deviceName"
          :label="$t('apartmentRoomDetail.deviceName')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="isOnline"
          :formatter="this.$util.onlineFormat"
          :label="$t('apartmentRoomDetail.onlineStatus')"
          align="center"
        ></el-table-column>
        <el-table-column
          prop
          :label="$t('apartmentRoomDetail.operate')"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              :title="$t('apartmentRoomDetail.detail')"
              @click="handleEdit(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 3px">
        <Pagings
          :total="total"
          :offset="pageData.offset"
          :pageSize="pageData.pageNumber"
          @handleSizeChangeSub="handleSizeChange"
          @handleCurrentChangeSub="handleCurrentChange"
        ></Pagings>
      </div>
    </el-card>
  </el-form>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "apartmentRoomDetail", // 公寓房间详情
  props: ["infoData", "roomData", "tabIndex", "sonTabsItem"],
  data() {
    return {
      add4GNetLockVisible: false, //4g门锁
      addNBNetLockVisible: false, //nb门锁
      addGatewayVisible: false, //新增网关
      addTenantVisible: false, //新增租客
      reletVisible: false, //续租
      addOfflineVisible: false, //添加离线锁
      addNetLockVisible: false, //添加联网锁
      checkInVisible: false,
      tenantListVisible: false,
      pageData: {
        offset: 1,
        pageNumber: 10,
      },
      total: 1, //总条数
      tableData: [],
      fourGNetLockForm: {
        lockId: "",
        lockName: this.roomData.roomName + "4G联网锁",
      },
      nbNetLockForm: {
        lockId: "",
        lockName: this.roomData.roomName + "NB联网锁",
      },
      offlineForm: {
        lockId: "",
        lockName:
          this.roomData.roomName +
          this.$t("apartmentRoomDetail.offlineLockHint"),
      },
      netLockForm: {
        gatewayId: "",
        gatewayList: [],
        lockId: "",
        lockName:
          this.roomData.roomName +
          this.$t("apartmentRoomDetail.networkLockHint"),
      },
      currRoomData: this.roomData, //当前房间信息
      formTenant: {
        tenantId: "",
        tenantName: "",
        sendMessageChecked: "",
        validType: "0",
        password: "",
        card: "",
        cloudUser: "",
        date1: new Date(),
        time1: this.$util.formatHalfTime(new Date()),
        date2: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        time2: "12:00",
        deviceType: "",
        manage: "0",
      },
      formTenantInfo: {
        tenantId: "",
        tenantName: "",
        mobile: "",
        email: "",
        deviceType: "", //初始化已经赋值
        deviceId: "", //初始化已经赋值
        beginTime: "",
        endTime: "",
        isManage: "0",
      },
      tenantList: [],
      tenantPageData: {
        tenantOffset: 1,
        tenantPageNumber: 10,
      },
      tenantTotal: 1, //总条数
      currCheckInRoomData: {}, //当前入住房间
      currentTenantRow: "", //租客列表当前选择的租客
      tenantData: null,
      authInfoForm: {
        infoId: "",
        authorizationName: "",
        authorizationType: "",
        authorizationContent: "",
      },
      deviceList: "",
      dateRadio: 0,
      reletEndDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      reletEndTime: "12:00",
      currLinkerData: "",
      formAddTenant: {
        //提交表单
        tenantId: "",
        tenantName: "",
        tenantIdentityId: "",
        mobile: "",
        email: "",
      },
      showAddLockBtn: true,
      showAddGatewayBtn: true,
      gatewayForm: {
        addGatewayName:
          this.$t("apartmentRoomDetail.gatewayHint") + this.roomData.roomName,
        addGatewayNum: "",
        // gatewayList:this.$store.state.gatewayList
      },
      pickerOptionsEnd: {
        disabledDate: this.disabledDate,
      },
      selectForm: {
        //租客列表的查询条件
        tenantName: "",
      },
    };
  },
  components: {
    Pagings,
  },
  watch: {
    tabIndex(val) {
      var sonTabsItem = this.sonTabsItem;
      for (var str in sonTabsItem) {
        if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
          var sonTabItemList = sonTabsItem[str].tabsItem;
          for (var s in sonTabItemList) {
            if (
              sonTabItemList[s].name == val &&
              val != 1 &&
              sonTabItemList[s].type == 3
            ) {
              this.currRoomData = sonTabItemList[s].ref;
              this.deviceList = this.currRoomData.deviceList;
              if (this.deviceList != null && this.deviceList.length > 0) {
                this.formTenantInfo.deviceType = this.getDeviceTypeByList(
                  this.deviceList
                );
              }
              this.power();
              this.tenantPower();
              this.$store.commit("getApartmentRoomUsableGateway", {
                roomId: this.currRoomData.roomId,
              }); //加载网关详细
              if (
                this.currRoomData.tenantId != "" &&
                this.currRoomData.tenantId != null
              ) {
                this.getTenantDetail(this.currRoomData.tenantId);
              }
            }
          }
        }
      }
    },
  },

  created() {
    var sonTabsItem = this.sonTabsItem;
    for (var str in sonTabsItem) {
      if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
        var sonTabItemList = sonTabsItem[str].tabsItem;
        for (var s in sonTabItemList) {
          if (
            sonTabItemList[s].name == this.tabIndex &&
            this.tabIndex != 1 &&
            sonTabItemList[s].type == 3
          ) {
            this.currRoomData = sonTabItemList[s].ref;
            this.deviceList = this.currRoomData.deviceList;
            // console.log(window.JSON.stringify(this.deviceList));
            if (this.deviceList != null && this.deviceList.length > 0) {
              this.formTenantInfo.deviceType = this.getDeviceTypeByList(
                this.deviceList
              );
            }
            this.$store.commit("getApartmentRoomUsableGateway", {
              roomId: this.currRoomData.roomId,
            }); //加载网关详细
            if (
              this.currRoomData.tenantId != "" &&
              this.currRoomData.tenantId != null
            ) {
              this.getTenantDetail(this.currRoomData.tenantId);
            }
            // alert(window.JSON.stringify(sonTabItemList[s].ref));
            this.power();
            this.tenantPower();
          }
        }
      }
    }
  },
  methods: {
    //租客列表查询
    onSelectTenant() {
      this.tenantPower();
    },
    //时间控件限制
    disabledDate(time) {
      var date = new Date(this.formTenantInfo.endTime);
      date = date.setFullYear(date.getFullYear() + 1);
      return time.getTime() > new Date(date).getTime();
    },
    //确定增加租客
    confirmAddTenant() {
      var formData = new FormData();
      formData.append("tenantName ", this.formAddTenant.tenantName);
      formData.append("tenantIdentityId ", this.formAddTenant.tenantIdentityId);
      formData.append("tenantPhoneCountryId", 86);
      formData.append("tenantPhone", this.formAddTenant.mobile);
      formData.append("tenantEmail", this.formAddTenant.email);
      formData.append("tenantType", 0);
      formData.append("isSendSms", 0);
      formData.append("isLimit", 0);
      this.$server.exam("/customer/tenant/addTenant", formData).then((data) => {
        if (data.code == 200) {
          this.$message({
            message: data.message,
            type: "success",
          });
          this.addTenantVisible = false;
          (this.formAddTenant = {
            tenantId: "",
            tenantName: "",
            mobile: "",
            email: "",
          }),
            this.tenantPower();
          this.tenantListVisible = true;
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    //关闭增加租客
    closeAddTenant() {
      this.checkInVisible = true;
      this.addTenantVisible = false;
    },
    //打开增加租客
    addTenant() {
      this.checkInVisible = false;
      this.addTenantVisible = true;
    },
    //确定续租
    reletConfirm() {
      this.reletVisible = false;
      this.$confirm(
        this.$t("apartmentRoomDetail.tenantCheckIn-confirm1") +
          this.currRoomData.tenantName +
          this.$t("apartmentRoomDetail.tenantCheckIn-confirm2") +
          this.$util.formartDate(this.reletEndDate) +
          " " +
          this.reletEndTime +
          ":00" +
          this.$t("apartmentRoomDetail.tenantCheckIn-confirm3"),
        "提示",
        {
          confirmButtonText: this.$t("apartmentRoomDetail.confirm"),
          cancelButtonText: this.$t("apartmentRoomDetail.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var formData = new FormData();
          formData.append("authInfoId", this.authInfoForm.infoId);
          formData.append("roomId", this.currLinkerData.roomId);
          formData.append("tenantId", this.currLinkerData.tenantId);
          formData.append(
            "beginTime",
            this.$util.formartDateTime(this.currLinkerData.beginTime)
          );
          formData.append(
            "endTime",
            this.$util.formartDate(this.reletEndDate) +
              " " +
              this.reletEndTime +
              ":00"
          );
          formData.append("isLimit", 1);
          this.$server
            .exam("/customer/apartment/editTenantInfo", formData)
            .then((data) => {
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.getTenantDetail(this.currLinkerData.tenantId);
                this.$store.commit("getApartmentDetail", {
                  apartmentId: this.infoData.apartmentId,
                }); //加载公寓楼栋
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("apartmentRoomDetail.cancelCheckIn"),
          });
        });
    },
    //日期改变事件
    dateChange() {
      switch (this.dateRadio) {
        case 0: //日
          this.reletEndDate = new Date(
            new Date().getTime() + 24 * 60 * 60 * 1000
          );
          break;
        case 1: //周
          this.reletEndDate = new Date(
            new Date().getTime() + 7 * 24 * 60 * 60 * 1000
          );
          break;
        case 2: //月
          var date = new Date();
          date.setMonth(date.getMonth() + 1);
          this.reletEndDate = new Date(date);
          break;
        case 3: //季
          var date = new Date();
          date.setMonth(date.getMonth() + 3);
          this.reletEndDate = new Date(date);
          break;
        case 4: //年
          var date = new Date();
          date.setFullYear(date.getFullYear() + 1);
          this.reletEndDate = new Date(date);
          break;
      }
    },
    //打开续租
    relet() {
      this.reletVisible = true;
    },
    //退租
    checkOut() {
      this.$confirm(
        this.$t("apartmentRoomDetail.tenantCheckOut-confirm1") +
          this.currRoomData.roomName +
          this.$t("apartmentRoomDetail.tenantCheckOut-confirm2") +
          this.currRoomData.tenantName +
          this.$t("apartmentRoomDetail.tenantCheckOut-confirm3"),
        "提示",
        {
          confirmButtonText: this.$t("apartmentRoomDetail.confirm"),
          cancelButtonText: this.$t("apartmentRoomDetail.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var formData = new FormData();
          formData.append("isDelete", 0);
          // switch (this.currRoomData.deviceList[0].deviceType) {
          //   case 2: //离线锁
          //     formData.append("isDelete", 0);
          //     break;
          //   case 1: //联网锁
          //     formData.append("isDelete", 0);
          //     break;
          //   case 4: //联网锁
          //     formData.append("isDelete", 0);
          //     break;
          // }
          formData.append("roomId", this.roomData.roomId);
          formData.append("tenantId", this.currRoomData.tenantId);
          this.$server
            .exam("/customer/apartment/checkOut", formData)
            .then((data) => {
              this.tenantInfoVisible = false;
              if (data.code == 200) {
                this.$message({
                  message: data.message,
                  type: "success",
                });
                var sonTabsItem = this.sonTabsItem;
                for (var str in sonTabsItem) {
                  if (
                    sonTabsItem[str].apartmentId == this.infoData.apartmentId
                  ) {
                    var temp = sonTabsItem[str].tabsItem;
                    // alert(window.JSON.stringify(temp));
                    var strItem = [];
                    for (var s in temp) {
                      if (temp[s].id == this.currRoomData.roomId) {
                        temp[s].ref.tenantId = "";
                        temp[s].ref.tenantName = "";
                        temp[s].ref.beginTime = "";
                        temp[s].ref.endTime = "";
                        temp[s].ref.isAuthorized = 0;
                      }
                    }
                  }
                }
                this.$store.commit("getApartmentDetail", {
                  apartmentId: this.infoData.apartmentId,
                }); //加载公寓楼栋
              } else {
                this.$message({
                  message: data.message,
                  type: "warning",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("apartmentRoomDetail.cancelCheckOut"),
          });
        });
    },
    getTenantDetail(tenantId) {
      var formData = new FormData();
      formData.append("tenantId", tenantId);
      this.$server
        .exam("/customer/tenant/getTenantDetail", formData)
        .then((data) => {
          if (data.code == 200) {
            var tenantData = data.data;
            var tempDeviceData = this.roomData.deviceList.filter((item) => {
              return item.deviceType != 0;
            });
            if (
              tenantData.tenantAuthorizationList.length > 0 &&
              tenantData.tenantAuthorizationList != null
            ) {
              // console.log(window.JSON.stringify(this.currRoomData));
              if (this.currRoomData.isAuthorized == 1) {
                for (var str in tenantData.tenantAuthorizationList) {
                  //  console.log(tempDeviceData[0].deviceId+"------"+tenantData.tenantAuthorizationList[str].lockId);
                  if (
                    tempDeviceData[0].deviceId ===
                    tenantData.tenantAuthorizationList[str].lockId
                  ) {
                    //  console.log(tenantData.tenantAuthorizationList[str].lockId);
                    //  console.log(window.JSON.stringify(tenantData.tenantAuthorizationList[str]));
                    this.authInfoForm.infoId =
                      tenantData.tenantAuthorizationList[str].infoId;
                    this.authInfoForm.authorizationName =
                      tenantData.tenantAuthorizationList[str].authorizationName;
                    this.authInfoForm.authorizationType =
                      tenantData.tenantAuthorizationList[str].validUser == 0
                        ? "管理员"
                        : tenantData.tenantAuthorizationList[str].validUser == 1
                        ? "普通用户"
                        : tenantData.tenantAuthorizationList[str].validUser == 2
                        ? "临时用户"
                        : "离线用户";
                    this.authInfoForm.authorizationType +=
                      "(" +
                      (tenantData.tenantAuthorizationList[str].validType == 0
                        ? "密码"
                        : tenantData.tenantAuthorizationList[str].validType == 1
                        ? "门卡"
                        : tenantData.tenantAuthorizationList[str].validType == 2
                        ? "身份证"
                        : tenantData.tenantAuthorizationList[str].validType == 3
                        ? "指纹"
                        : "蓝牙") +
                      ")";
                    this.authInfoForm.authorizationContent =
                      this.getJSONValidData(
                        tempDeviceData[0].deviceType,
                        tenantData.tenantAuthorizationList[str].validData
                      );
                    break;
                  }
                }
              }
            }
            if (
              tenantData.apartmentRoomTenantLinkers.length > 0 &&
              tenantData.apartmentRoomTenantLinkers != null
            ) {
              for (var str in tenantData.apartmentRoomTenantLinkers) {
                if (
                  this.roomData.roomId ==
                  tenantData.apartmentRoomTenantLinkers[str].roomId
                ) {
                  this.currLinkerData =
                    tenantData.apartmentRoomTenantLinkers[str];
                  this.formTenantInfo.beginTime = this.$util.formartDateTime(
                    tenantData.apartmentRoomTenantLinkers[str].beginTime
                  );
                  this.formTenantInfo.endTime = this.$util.formartDateTime(
                    tenantData.apartmentRoomTenantLinkers[str].endTime
                  );
                  this.reletEndDate = this.$util.formartDateTime(
                    new Date(this.formTenantInfo.endTime).getTime() +
                      24 * 3600000
                  ); //赋值续租时间+1日
                  this.formTenantInfo.isManage =
                    tenantData.apartmentRoomTenantLinkers[str].isManager;
                }
              }
            }
            this.tenantData = tenantData;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    //确定入住
    confirmCheckIn() {
      var tenantData = this.currentTenantRow;
      var checkInRoomData = this.currCheckInRoomData;
      var formData = new FormData();
      var date1 = this.$util.formartDate(this.formTenant.date1);
      var time1 = this.formTenant.time1 + ":00";
      var date2 = this.$util.formartDate(this.formTenant.date2);
      var time2 = this.formTenant.time2 + ":00";
      if (this.formTenant.time1 == "" || this.formTenant.time1 == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.beginDate-input"),
          type: "error",
        });
        return false;
      }
      if (this.formTenant.time2 == "" || this.formTenant.time2 == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.chooseTime"),
          type: "error",
        });
        return false;
      }
      formData.append("roomId", checkInRoomData.roomId);
      formData.append("isLimit", 1);
      formData.append("tenantId", tenantData.tenantId);
      formData.append("isManager", parseInt(this.formTenant.manage));
      var authList = [];
      var authObj = {};
      authObj.authorizationName = this.currentTenantRow.tenantName;
      authObj.isLocked = 0;
      authObj.isOpen = 0;
      authObj.isOpenPublicDoor = 0;
      //搜索出门锁
      // if(checkInRoomData.deviceList==""||checkInRoomData.deviceList.length==0){
      //   this.$message({
      //     message: this.$t('apartmentRoomDetail.noBindLock'),
      //     type: "error"
      //   });
      //   return false;
      // }
      var lockData = checkInRoomData.deviceList;
      var deviceType = this.getDeviceTypeByList(checkInRoomData.deviceList); //获取设备类型
      switch (deviceType) {
        case 2: //离线锁
          authObj.validUser = 3; //离线用户
          authObj.validType = 0; //密码
          // switch (checkInRoomData.deviceList[0].offLineLockType) {
          //   case 0: //8位锁码--传日期
          //     formData.append("beginTime", date1 + " " + time1);
          //     formData.append("endTime", date2 + " " + time2);
          //     break;
          //   case 1: //7位锁码--传日期+时间
          //     formData.append("beginTime", date1 + " " + time1);
          //     formData.append("endTime", date2 + " " + time2);
          //     break;
          // }
          break;
        case 1: //联网锁
          authObj.validUser = 2; //临时用户
          authObj.validType = 0; //密码
          formData.append("beginTime", date1 + " " + time1);
          formData.append("endTime", date2 + " " + time2);
          break;
        case 3: //NB联网锁
          authObj.validUser = 2; //临时用户
          authObj.validType = 0; //密码
          formData.append("beginTime", date1 + " " + time1);
          formData.append("endTime", date2 + " " + time2);
          break;
        case 4: //蓝牙锁
          authObj.validUser = 3; //离线用户
          authObj.validType = 0; //密码
          break;
        case 5: //4G联网锁
          authObj.validUser = 2; //临时用户
          authObj.validType = 0; //密码
          formData.append("beginTime", date1 + " " + time1);
          formData.append("endTime", date2 + " " + time2);
          break;
      }
      formData.append("beginTime", date1 + " " + time1);
      formData.append("endTime", date2 + " " + time2);
      //判断授权内容
      // switch (this.formTenant.validType) {
      //   case "0":
      //     authObj.validType = 0;
      //     authObj.validData = this.formTenant.password;
      //     break;
      //   case "1":
      //     authObj.validType = 1;
      //     authObj.validData = this.formTenant.card;
      //     break;
      //    case "2":
      //     authObj.validType = 4;
      //      break;
      // }
      //判断是否发送信息
      switch (this.formTenant.sendMessageChecked) {
        case "": //不发送信息
          authObj.isSendSms = 0;
          break;
        case "0": //发送短信
          authObj.isSendSms = 1;
          authObj.sendChannel = 0;
          authObj.countryId = 86;
          if (
            this.currentTenantRow.tenantPhone == null ||
            this.currentTenantRow.tenantPhone == ""
          ) {
            this.$message({
              message: this.$t("apartmentRoomDetail.tenantPhone-input"),
              type: "success",
            });
            return false;
          }
          authObj.mobile = this.currentTenantRow.tenantPhone;
          break;
        case "1": //发送邮箱
          authObj.isSendSms = 1;
          authObj.sendChannel = 1;
          authObj.countryId = 86;
          if (
            this.currentTenantRow.tenantEmail == null ||
            this.currentTenantRow.tenantEmail == ""
          ) {
            this.$message({
              message: this.$t("apartmentRoomDetail.email-input1"),
              type: "success",
            });
            return false;
          }
          authObj.email = this.currentTenantRow.tenantEmail;
          break;
      }
      authList.push(authObj);
      formData.append("authorizationList", window.JSON.stringify(authList));
      this.$server
        .exam("/customer/apartment/checkIn", formData)
        .then((data) => {
          if (data.code == 200) {
            this.checkInVisible = false;
            this.currRoomData = checkInRoomData;
            switch (deviceType) {
              case 2: //离线锁
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.$store.commit("getApartmentDetail", {
                  apartmentId: this.infoData.apartmentId,
                }); //加载公寓楼栋
                break;
              case 5: //NB联网锁
              case 3: //NB联网锁
              case 1: //联网锁
                if (data.data[0] == null || data.data[0] == "") {
                  this.$message({
                    message: this.$t("update.lockError"),
                    type: "warning",
                  });
                  this.$store.commit("getApartmentDetail", {
                    apartmentId: this.infoData.apartmentId,
                  }); //加载公寓楼栋
                  return false;
                }
                const loading = this.$loading({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                var obj = {};
                obj.rId = data.data[0].recordId;
                obj.loading = loading;
                obj.opType = "tenantDetailCheckIn";
                obj.othis = this;
                obj.apartmentId = this.infoData.apartmentId;
                obj.tenantId = tenantData.tenantId;
                this.$store.dispatch("checkResult", obj); //等待回调
                //this.getTenantDetail(tenantData.tenantId);
                break;
              case 4: //蓝牙锁
                this.$message({
                  message: data.message,
                  type: "success",
                });
                this.$store.commit("getApartmentDetail", {
                  apartmentId: this.infoData.apartmentId,
                }); //加载公寓楼栋
                break;
            }
            var sonTabsItem = this.sonTabsItem;
            for (var str in sonTabsItem) {
              if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
                var temp = sonTabsItem[str].tabsItem;
                var strItem = [];
                for (var s in temp) {
                  if (temp[s].id == this.currRoomData.roomId) {
                    temp[s].ref.tenantId = tenantData.tenantId;
                    temp[s].ref.tenantName = tenantData.tenantName;
                    temp[s].ref.beginTime = tenantData.beginTime;
                    temp[s].ref.endTime = tenantData.endTime;
                    temp[s].ref.isAuthorized = 1;
                  }
                }
              }
            }
            this.getTenantDetail(tenantData.tenantId); //加载租客信息
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    //确认选择租客
    confirmChooseTenant() {
      if (this.currentTenantRow == "" || this.currentTenantRow == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.chooseTenant1"),
          type: "warning",
        });
        return false;
      }
      this.checkInVisible = true;
      this.tenantListVisible = false;
      this.formTenant.tenantName = this.currentTenantRow.tenantName;
    },
    //选择租客row
    handleCurrentChangeDetail(val) {
      this.currentTenantRow = val;
    },
    //打开选择租客
    chooseTenant() {
      this.checkInVisible = false;
      this.tenantListVisible = true;
    },

    openCheckIn() {
      this.currCheckInRoomData = this.currRoomData;
      if (this.tableData.length == 0 || this.tableData == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.noBindLock"),
          type: "error",
        });
        return false;
      }
      // alert(window.JSON.stringify(this.currCheckInRoomData));
      this.formTenant.tenantId = "";
      this.formTenant.tenantName = "";
      this.formTenantInfo.deviceType = this.formTenantInfo.deviceType;
      this.checkInVisible = true;
    },

    //重新授权
    reauthorization() {
      this.currCheckInRoomData = this.currRoomData;
      if (this.tableData.length == 0 || this.tableData == null) {
        this.$message({
          message: this.$t("apartmentRoomDetail.noBindLock"),
          type: "error",
        });
        return false;
      }
      var formData = new FormData();
      formData.append("authorizationName", this.currRoomData.tenantName);
      formData.append("isSendSms", 0);
      // if(this.currLinkerData.isSendSms==1){//0不发信息，1发信息
      //    if(this.currLinkerData.sendChannel==0){//0手机，1邮箱
      //      formData.append("countryId", this.currLinkerData.countryId);
      //      formData.append("mobile", this.currLinkerData.mobile);
      //    }else{
      //      formData.append("email", this.currLinkerData.email);
      //    }
      // }
      formData.append("isLocked", 0);
      formData.append("isOpen", 0);
      formData.append("isOpenPublicDoor", 0);
      formData.append("roomId", this.currRoomData.roomId);
      formData.append("tenantId", this.currRoomData.tenantId);
      formData.append("validType", 0); //0密码
      switch (this.formTenantInfo.deviceType) {
        case 1: //联网锁
          formData.append("validUser", 2);
          break;
        case 2: //离线锁
          formData.append("validUser", 3);
          break;
        case 3: //NB联网锁
          formData.append("validUser", 2);
          break;
        case 4: //蓝牙锁
          formData.append("validUser", 3);
          break;
        case 5: //NB联网锁
          formData.append("validUser", 2);
          break;
      }
      this.$server
        .exam("/customer/apartment/addTenantAuthorization", formData)
        .then((data) => {
          if (data.code == 200) {
            if (this.formTenantInfo.deviceType == 1) {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              var obj = {};
              obj.rId = data.data[0].recordId;
              obj.loading = loading;
              obj.opType = "tenantDetailCheckIn";
              obj.othis = this;
              obj.apartmentId = this.infoData.apartmentId;
              obj.tenantId = this.currRoomData.tenantId;
              this.$store.dispatch("checkResult", obj); //等待回调
              this.getTenantDetail(this.currRoomData.tenantId);
            } else {
              this.$message({
                message: data.message,
                type: "success",
              });
              this.power();
              this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId,
              }); //加载公寓楼栋
              this.getTenantDetail(this.currRoomData.tenantId);
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
      // this.formTenant.tenantId = "";
      // this.formTenant.tenantName = "";
      // this.checkInVisible = true;
    },

    handleEdit(index, row) {
      this.$mainInfo.addDevcieDetail(row);
    },
    add4GNetLock() {
      //添加4G联网锁
      var formData = new FormData();
      formData.append("deviceId", this.fourGNetLockForm.lockId);
      formData.append("deviceName", this.fourGNetLockForm.lockName);
      formData.append("roomId", this.currRoomData.roomId);
      formData.append("secondDeviceType", 5);
      this.$server
        .exam("/customer/apartment/bindDevice", formData)
        .then((data) => {
          if (data.code == 200) {
            var rtnData = data["data"];
            this.addNetLockVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            var obj = {};
            obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "netLock";
            obj.othis = this;
            obj.deviceType = 5;
            this.$store.dispatch("checkResult", obj);
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    addNBNetLock() {
      //添加NB联网锁
      var formData = new FormData();
      formData.append("deviceId", this.nbNetLockForm.lockId);
      formData.append("deviceName", this.nbNetLockForm.lockName);
      formData.append("roomId", this.currRoomData.roomId);
      formData.append("secondDeviceType", 3);
      this.$server
        .exam("/customer/apartment/bindDevice", formData)
        .then((data) => {
          if (data.code == 200) {
            var rtnData = data["data"];
            this.addNetLockVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            var obj = {};
            obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "netLock";
            obj.othis = this;
            obj.deviceType = 3;
            this.$store.dispatch("checkResult", obj);
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    addOfflineLock() {
      //添加离线锁
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var formData = new FormData();
      formData.append("deviceName", this.offlineForm.lockName);
      formData.append("lockPassword", this.offlineForm.lockId);
      formData.append("roomId", this.currRoomData.roomId);
      this.$server
        .exam("/customer/apartment/bindOfflineLock", formData)
        .then((data) => {
          loading.close();
          if (data.code == 200) {
            this.addOfflineVisible = false;
            this.$message({
              message: data.message,
              type: "success",
            });
            this.power();
            this.$store.commit("getApartmentDetail", {
              apartmentId: this.infoData.apartmentId,
            }); //加载公寓楼栋
            var sonTabsItem = this.sonTabsItem;
            for (var str in sonTabsItem) {
              if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
                var temp = sonTabsItem[str].tabsItem;
                var strItem = [];
                for (var s in temp) {
                  if (temp[s].id == this.currRoomData.roomId) {
                    var obj = {};
                    obj.deviceId = this.offlineForm.lockId;
                    obj.deviceName = this.offlineForm.lockName;
                    obj.deviceType = 2;
                    if (this.offlineForm.lockId.length == 7) {
                      obj.offLineLockType = 1; //7位锁码
                    } else {
                      obj.offLineLockType = 0; //8位锁码
                    }
                    temp[s].ref.deviceList.push(obj);
                  }
                }
              }
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    addGateway() {
      //添加网关
      var formData = new FormData();
      formData.append("deviceName", this.gatewayForm.addGatewayName);
      formData.append("deviceId", this.gatewayForm.addGatewayNum);
      formData.append("deviceType", 0);
      formData.append("roomId", this.currRoomData.roomId);
      this.$server
        .exam("/customer/apartment/bindFirstDevice", formData)
        .then((data) => {
          if (data.code == 200) {
            var rtnData = data["data"][0];
            this.showAddGatewayBtn = false;
            this.addGatewayVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            var obj = {};
            obj.roomId = this.currRoomData.roomId;
            // obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "addGateway";
            obj.othis = this;
            this.$store.dispatch("checkResult", obj);
            var sonTabsItem = this.sonTabsItem;
            for (var str in sonTabsItem) {
              if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
                var temp = sonTabsItem[str].tabsItem;
                var strItem = [];
                for (var s in temp) {
                  if (temp[s].id == this.currRoomData.roomId) {
                    var obj = {};
                    obj.deviceId = this.gatewayForm.addGatewayNum;
                    obj.deviceName = this.gatewayForm.addGatewayName;
                    obj.deviceType = 0;
                    temp[s].ref.deviceList.push(obj);
                  }
                }
              }
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    addNetLock() {
      //添加联网锁
      var formData = new FormData();
      formData.append("firstDeviceId", this.netLockForm.gatewayId);
      formData.append("firstDeviceType", 0);
      formData.append("roomId", this.currRoomData.roomId);
      formData.append("secondDeviceId", this.netLockForm.lockId);
      formData.append("secondDeviceName", this.netLockForm.lockName);
      formData.append("secondDeviceType", 1);
      this.$server
        .exam("/customer/apartment/bindSecondDevice", formData)
        .then((data) => {
          if (data.code == 200) {
            var rtnData = data["data"][0];
            this.addNetLockVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            var obj = {};
            obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "netLock";
            obj.othis = this;
            obj.deviceType = 1;
            this.$store.dispatch("checkResult", obj);
            // var sonTabsItem = this.sonTabsItem;
            //   for (var str in sonTabsItem) {
            //     if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
            //       var temp = sonTabsItem[str].tabsItem;
            //       var strItem = [];
            //       for (var s in temp) {
            //         if (temp[s].id == this.currRoomData.roomId) {
            //           var obj={};
            //           obj.deviceId=this.offlineForm.lockId;
            //           obj.deviceName=this.offlineForm.lockName;
            //           obj.deviceType=1;
            //           obj.offLineLockType=1//7位锁码
            //           temp[s].ref.deviceList.push(obj);
            //         }
            //       }
            //     }
            //   }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    getJSONValidData(deviceType, jsonData) {
      switch (deviceType) {
        case 3: //联网锁
        case 5: //联网锁
        case 1: //联网锁
          return jsonData;
          break;
        case 2: //离线锁
          var data = window.JSON.parse(jsonData);
          return data.data;
          break;
        case 4: //蓝牙锁
          return jsonData;
          break;
      }
    },
    getDeviceTypeByList(deviceList) {
      var rtn = "";
      for (var str in deviceList) {
        if (deviceList[str].deviceType != 0) {
          this.formTenantInfo.deviceId = deviceList[str].deviceId;
          rtn = deviceList[str].deviceType;
        }
      }
      return rtn;
    },
    power() {
      var formData = new FormData();
      formData.append("roomId", this.currRoomData.roomId);
      formData.append("isPublic", 0);
      formData.append("pageNo", this.pageData.offset);
      formData.append("pageSize", this.pageData.pageNumber);
      this.$server.exam("/customer/lock/listLock", formData).then((data) => {
        if (data.code == 200) {
          this.tableData = data.data.records;
          this.total = data.data.total;
          if (this.tableData != null && this.tableData.length > 0) {
            var deviceList = this.tableData;
            //  console.log(window.JSON.stringify(deviceList));
            for (var str in deviceList) {
              switch (deviceList[str].deviceType) {
                case 0:
                  this.showAddGatewayBtn = false;
                  break;
                case 1:
                  this.showAddLockBtn = false;
                case 2:
                  this.showAddLockBtn = false;
                case 3:
                  this.showAddLockBtn = false;
                case 4:
                  this.showAddLockBtn = false;
                  break;
                case 5:
                  this.showAddLockBtn = false;
                  break;
              }
            }
          }
          // this.oAssEquipmentDto.offset = 1;
          // this.oAssEquipmentDto.pageNumber = data.data.pages;
        } else {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },

    handleSizeChange(val) {
      this.oAssEquipmentDto.pageNumber = val;
      this.power();
    },

    handleCurrentChange(val) {
      this.oAssEquipmentDto.offset = val;
      this.power();
    },

    tenantPower() {
      var formData = new FormData();
      if (
        this.selectForm.tenantName != "" &&
        this.selectForm.tenantName != null
      ) {
        formData.append("tenantName", this.selectForm.tenantName);
      }
      // formData.append("apartmentId", this.infoData.apartmentId);
      formData.append("pageNo", this.tenantPageData.tenantOffset);
      formData.append("pageSize", this.tenantPageData.tenantPageNumber);
      this.$server
        .exam("/customer/tenant/listTenant", formData)
        .then((data) => {
          if (data.code == 200) {
            this.tenantList = data.data.records;
            this.tenantTotal = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
    },
    tenantHandleSizeChange(val) {
      this.tenantPageData.tenantPageNumber = val;
      this.tenantPower();
    },
    tenantHandleCurrentChange(val) {
      this.tenantPageData.tenantOffset = val;
      this.tenantPower();
    },
  },
};
</script>

<style scoped>
/*清除浮动代码*/
.clearfloat:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}
.clearfloat {
  zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/device/apartmentRoomDetail.vue